import React from 'react'

function Error() {
  return <div>ERROR 404 NOT FOUND</div>
}

export default Error
